// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__17UP0","requiredAsterisk":"Info_requiredAsterisk__xc0hC"};